"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PlainText = void 0;
var styled_components_1 = __importDefault(require("styled-components"));
exports.PlainText = styled_components_1.default.span(function (_a) {
    var _b = _a.theme, fontWeights = _b.fontWeights, colors = _b.colors;
    return "\n    font-weight: ".concat(fontWeights.normal, ";\n    color: ").concat(colors.body, ";\n  ");
});
